import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ICompany } from 'src/app/interfaces/company';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { BIDService } from 'src/app/services/common/bid.service';
import { CIDService } from 'src/app/services/common/cid.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { HoldingService } from 'src/app/services/http/business/holding/holding.service';
import { MatDialogRef, MatSelect } from '@angular/material';
import { IContractType } from 'src/app/interfaces/contractType';

@Component({
  selector: 'app-contract-search',
  templateUrl: './contract-search.component.html',
  styleUrls: ['./contract-search.component.css']
})
export class ContractSearchComponent implements OnInit {
  isOwner: boolean;
  form: FormGroup;
  companyList: ICompany[];
  contractType: IContractType;

  constructor(
    private fb: FormBuilder,
    private staticValueService: StaticValueService,
    private bidService: BIDService,
    private cidService: CIDService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private dialog: MatDialogRef<ContractSearchComponent>
  ) { }

  ngOnInit() {

    this.createForm();
    this.checkOwner();
    this.getContractType();
  }
  createForm() {
    this.form = this.fb.group({
      FirstName: [
        null,
        Validators.compose([
          Validators.maxLength(50),
          Validators.pattern("([\u0600-\u06FF 0-9-]+)")
        ])
      ],
      LastName: [
        null,
        Validators.compose([
          Validators.maxLength(50),
          Validators.pattern("([\u0600-\u06FF 0-9-]+)")
        ])
      ],
      RoleName: [
        null,
        Validators.compose([
          Validators.maxLength(50),
          Validators.pattern("([\u0600-\u06FF 0-9-]+)")
        ])
      ],
      NationalCode: [
        null,
        Validators.compose([
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ],
      ContractTypeId: [null],
      ContractNumber: [null],
    });
  }
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.getCompanyList();
      else
        this.form.setValue({
          BranchEncryptId: this.bidService.getBID(),
        });
    });
  }


  getContractType() {
    this.staticValueService.ContractType().subscribe(res => {
      this.contractType = res;
    });
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
  }

  submit(form: any) {

    this.dialog.close(form);
  }

  onNoClick() {
    this.dialog.close();
  }


}

